import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { BRIEF_SCRIPTING_QUERY_KEY } from "@entities/brief/lib/constants";
import { ICreateScriptComment } from "@shared/lib/types/briefCampains";
import { BriefConfigService } from "../../services/briefConfigService";
import { BRIEF_CAMPAIGNS_LIST_QUERY_KEY } from "@entities/campaigns/lib/contsants";

export function useAddScriptToTask(briefId: string) {
  const {
    mutate: addScriptToTask,
    isLoading: isCreating,
    isSuccess: isCreated,
  } = useMutation({
    mutationFn: (payload: {
      campaignInfluencerId: string;
      deliverableConfigRefId: string;
      taskId: string;
    }) =>
      BriefConfigService.addScriptToTask(payload).catch(async (err) => {
        const responseBody = await err.response?.json?.();
        if (responseBody?.msg) ToastService.error(responseBody.msg);
        throw err;
      }),
    options: {},
    onSuccess: (c) => {
      c.invalidateQueries({
        queryKey: [...BRIEF_CAMPAIGNS_LIST_QUERY_KEY(briefId)],
      });
    },
  });

  return { addScriptToTask, isCreating, isCreated };
}
